// Data do evento em UTC (a API manda "YYYY-MM-DD"; sem UTC mostraria o dia anterior)
export const formatLeadDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("pt-BR", { timeZone: "UTC" });
};

// Status do DJ no pedido (pivot lead_artist) tem prioridade sobre o status global
export const getEffectiveStatus = (lead) =>
  lead.pivot?.status?.toLowerCase() || lead.status?.toLowerCase();

const HIDDEN_STATUSES = ["cancelled", "cancelado", "rejected", "recusado", "declined", "completed", "concluido", "finalizado"];

// Pedido liberado que ainda deve aparecer na lista (sem cancelados/recusados e sem contrato,
// que já vai para Eventos). Pedido bloqueado não tem status e sempre aparece.
export const isVisibleLead = (lead) => {
  if (lead.locked) return true;
  if (HIDDEN_STATUSES.includes(getEffectiveStatus(lead))) return false;
  if ((lead.contract && Object.keys(lead.contract).length > 0) || lead.contract_id) return false;
  return true;
};
